import type { Dictionary } from '../LocalizationProvider.types';

export const getMonthNames = (dict: Dictionary) => [
  dict['month-january'],
  dict['month-february'],
  dict['month-march'],
  dict['month-april'],
  dict['month-may'],
  dict['month-june'],
  dict['month-july'],
  dict['month-august'],
  dict['month-september'],
  dict['month-october'],
  dict['month-november'],
  dict['month-december'],
];
